export const P00037CellModel = [
  { label: 'BIOV3-CL-E2P', ref: 1, v1: 60, v2: 161, v3: 92 },
  { label: 'BIOV3-CL-E3P', ref: 2, v1: 55, v2: 172, v3: 99 },
  { label: 'BIOV3-CL-E4P', ref: 3, v1: 55, v2: 240, v3: 145 },
  { label: 'BIOV3-CL-E7PX1', ref: 4, v1: 80, v2: 229, v3: 134 },
];
